import { observable } from "mobx";
import { Type } from "class-transformer";
import BankExportDownloadResponse from "./bankExportDownloadResponse";
import type { IBankExportDetail } from "./bankExport";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class PayGateRefundExportDetailResponse implements IBankExportDetail {
  id!: string;

  @observable
  name!: string;

  @observable
  @Type(() => Date)
  createdAt!: Date;

  @observable
  createdBy!: string;

  @observable
  paymentsIncludedCount!: number;

  @observable
  @Type(() => BankExportDownloadResponse)
  downloads!: BankExportDownloadResponse[];
}
